<script lang="ts">
import { ref, computed, reactive, defineComponent, toRefs, onMounted } from "vue";
export default defineComponent({
  name: "FlowItem",
  components: {},
  props: {
    item: {
      type: Object,
      default: {},
    },
    isBottom: {
      type: Boolean,
      default: false,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const constantMap = new Map([
      [1, { title: "删除到回收站", desc: "删除原因", operationDescType: "原因分类" }],
      [2, { title: "从回收站恢复", desc: "恢复原因", operationDescType: "原因分类" }],
      [3, { title: "作废", desc: "作废原因", operationDescType: "原因分类" }],
      [4, { title: "丢单", desc: "丢单原因", operationDescType: "丢单分类" }],
      [5, { title: "合同状态变更", desc: "变更原因", operationDescType: "变更分类" }],
      [6, { title: "关闭项目", desc: "关闭原因", operationDescType: "原因分类" }],
    ]);
    return { constantMap };
  },
});
</script>
<template>
  <div class="ub ub-ver ub-as ub-ps flow-log-wrapper">
    <div class="ub ub-as ub-ps ub-ver flow-log-div">
      <div class="bottom" v-if="isBottom"></div>
      <div class="first" v-if="isFirst"></div>
      <div class="ub ub-ver content">
        <div class="ub ub-ac ub-ps fw confirm-status">
          {{ item.operationTypeStr }}
        </div>
        <div class="ub ub-ac ub-pc user-name">
          <div>
            {{ (item.createName || item.operationTenantUserName) ? (item.operationTenantUserName || item.createName).substr(0, 1) : "客" }}
          </div>
        </div>
        <b class="left"><i class="left-arrow1"></i><i class="left-arrow2"></i></b>
        <div class="ub ub-as fw">
          <div class="ub ub-as ub-pc confirm-name">
            {{ item.operationTenantUserName || item.createName || "客户" }}
          </div>
          <div class="ub ub-ver ub-f1">
            <a-space :size="20" class="ub ub-pb">
              <div class="ub">
                <span class="labelName"> 工单状态: </span>
                <span>
                  {{ item.operationTypeStr }}
                </span>
              </div>
              <div class="ub">
                <span class="labelName">下一节点:</span>
                <span class="userName">{{ item.nextNodeUserName }}</span>
              </div>
              <span class="time">{{ item.createTime }}</span>
            </a-space>
            <a-space :size="20" class="ub ub-pb">
              <div class="ub ub-as ub-ps fw advise">
                <span class="labelName">备注: </span>
                {{ item.remark }}
              </div>
              <span></span>
            </a-space>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less">
.flow-log-wrapper {
  padding-left: 20px;
  box-sizing: border-box;
  // padding-top:44px;
  .flow-log-div {
    background-color: #ffffff;
    box-sizing: border-box;
    border-left: 1px solid #d8d8d8;
    padding: 22px 0 30px 0;
    .bottom {
      width: 1px;
      height: 50%;
      background-color: #fff;
      position: absolute;
      left: -1px;
      bottom: 0;
    }
    .first {
      width: 1px;
      height: 50%;
      background-color: #fff;
      position: absolute;
      left: -1px;
      top: 0;
    }
    .user-name {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      background-color: rgb(47, 123, 255) !important;
      position: absolute;
      left: -44px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 5;
      color: #fff;
      -webkit-print-color-adjust: exact;
    }
    .content {
      border: 1px solid #dcdcdc;
      min-height: 84px;
      min-width: 600px;
      margin-left: 28px;
      padding: 10px;
      box-sizing: border-box;
      font-size: 14px;
      padding-left: 0;
      padding-right: 30px;
      .confirm-status {
        position: absolute;
        top: -24px;
        font-weight: bold;
      }
      .confirm-name {
        width: 80px;
        color: #2f7bff;
      }
      .time {
        color: #2f7bff;
      }
      .left {
        width: 20px;
        height: 20px;
        position: absolute;
        left: -16px;
        top: 50%;
        z-index: 2; /*兼容ie8-*/
        transform: translateY(-50%);
        // border: 1px solid blue;
      }
      .left-arrow1,
      .left-arrow2 {
        width: 0;
        height: 0;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 5; /*兼容ie8-*/
        border-top: 8px transparent dashed;
        border-left: 8px transparent dashed;
        border-bottom: 8px transparent dashed;
        border-right: 8px white solid;
        overflow: hidden;
      }
      .left-arrow1 {
        border-right: 8px #ccc solid;
      }
      .left-arrow2 {
        left: 1px; /*重要*/
        border-right: 8px white solid;
      }
    }
  }
  .advise {
    margin-top: 10px;
    line-height: 25px;
    word-break: break-all;
  }
  .labelName {
    font-weight: bold;
    padding-right: 10px;
    box-sizing: border-box;
    white-space: nowrap;
  }
  .userName {
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    place-content: flex-start;
  }
}
</style>
